/**
 * React Query Hook for fetching case details
 */

import { useQuery } from '@tanstack/react-query';
import { getCaseById } from '@/api/services/casesApi';

/**
 * Query hook for fetching a specific case by ID
 * Uses TanStack Query with caching strategy
 * Cache key: ['case', id]
 */
export const useCaseDetail = (id: string | undefined, source?: string) => {
  return useQuery({
    queryKey: ['case', id],
    queryFn: async () => {
      if (!id) {
        throw new Error('Case ID is required');
      }
      return getCaseById(id, source);
    },
    enabled: !!id, // Only run query if id is provided
    retry: 1,
    staleTime: 1000 * 60 * 5, // 5 minutes
    gcTime: 1000 * 60 * 10, // 10 minutes (formerly cacheTime)
  });
};
